(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rivv-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rivv-hero-slider')) {
    customElements.define('rivv-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-rivv-track]');
        this.slides = [...this.querySelectorAll('[data-rivv-slide]')];
        this.dots = [...this.querySelectorAll('[data-rivv-dot]')];
        this.current = 0; this.timer = null; this.startX = 0;
        if (!this.track || this.slides.length < 2) return;
        this.querySelector('[data-rivv-prev]')?.addEventListener('click', () => this.go(this.current - 1, true));
        this.querySelector('[data-rivv-next]')?.addEventListener('click', () => this.go(this.current + 1, true));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.rivvDot), true)));
        this.addEventListener('mouseenter', () => this.stop()); this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop()); this.addEventListener('focusout', () => this.start());
        this.addEventListener('touchstart', (event) => { this.startX = event.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (event) => { const distance = event.changedTouches[0].clientX - this.startX; if (Math.abs(distance) > 45) this.go(this.current + (distance < 0 ? 1 : -1), true); }, { passive: true });
        this.start();
      }
      disconnectedCallback() { this.stop(); }
      go(index, restart = false) {
        this.current = (index + this.slides.length) % this.slides.length;
        this.track.style.transform = `translate3d(-${this.current * 100}%, 0, 0)`;
        this.slides.forEach((slide, position) => { const active = position === this.current; slide.setAttribute('aria-hidden', active ? 'false' : 'true'); slide.inert = !active; });
        this.dots.forEach((dot, position) => { const active = position === this.current; dot.classList.toggle('is-active', active); dot.setAttribute('aria-current', active ? 'true' : 'false'); });
        if (restart) { this.stop(); this.start(); }
      }
      start() { const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; if (this.dataset.autoplay !== 'true' || reduced || this.timer || this.slides.length < 2) return; const interval = Math.max(Number(this.dataset.interval) || 5000, 3000); this.timer = window.setInterval(() => this.go(this.current + 1), interval); }
      stop() { if (this.timer) window.clearInterval(this.timer); this.timer = null; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
